// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import { handleRouter } from './assets/js/handleRouter.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// GraphQL
import VueApollo from 'vue-apollo';
// import Print from 'vue-print-nb';
import { apolloProvider } from '@/graphql/apply-ware.js';

import '@/styles/main.styl';
Vue.use(ElementUI);
// Vue.use(Print);

Vue.use(VueApollo);
Vue.config.productionTip = false;
let lastIndexContent = '';

// 初始获取index.html内容（用于后续对比）
fetch('/index.html')
    .then(res => res.text())
    .then(content => {
        lastIndexContent = content;
    });

router.afterEach(() => {
    fetch('/index.html')
        .then(res => res.text())
        .then(newContent => {
            if (newContent !== lastIndexContent) {
                if (confirm('检测到新版本，是否刷新页面？')) {
                    lastIndexContent = newContent;
                    window.location.reload(true);
                }
            }
        });
});
router.beforeEach((to, from, next) => {
    handleRouter(to, from, next);
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    apolloProvider,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js